import { useMutation, useQueryClient } from '@tanstack/react-query';
import { campaignsKeys } from '../queryKeys';

/**
 * Shared machinery for the office promo-code writes (GOTU-9821): run
 * `mutationFn`, then invalidate that office's Discounts & Promo Codes history
 * — and no other office's — so the table shows what campaign-service recorded
 * rather than a row guessed client-side.
 *
 * Callers pass `onSuccess` / `onError` to `mutate(variables, callbacks)`, not
 * here: the dialogs are mounted only while open, and a hook-level callback
 * would still fire after an admin closed one mid-request.
 */
export const useOfficeDiscountHistoryMutation = (officeId, mutationFn) => {
  const queryClient = useQueryClient();

  return useMutation({
    // The dialogs render the service's message inline. The global toaster
    // reads `data.error`, which campaign-service bodies do not carry, so it
    // would only add a generic "Request failed" on top.
    meta: { skipGlobalErrorToaster: true },
    mutationFn,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: campaignsKeys.officeDiscountHistory(officeId) }),
  });
};
